import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CreditUsageSourcesStore } from 'pages/analytics/pages/creditUsage/pages/sources/store/creditUsageSourcesStore'

const CreditUsageSourcesContext = createContext<CreditUsageSourcesStore | null>(null)

export const useCreditUsageSourcesContext = () => {
  const context = useContext(CreditUsageSourcesContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with CreditUsageSourcesProvider'
    )

  return context
}

export const CreditUsageSourcesProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new CreditUsageSourcesStore(entities))

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <CreditUsageSourcesContext.Provider value={store}>
      {children}
    </CreditUsageSourcesContext.Provider>
  )
}
